export class TrainModelParam{
    name: string = "";
    datasetId: string = "";
    baseModel: string = "";
    repeat: number = 1;
    epoch: number = 20;
    batchSize: number = 1;
    samplerPrompt: string = "";
    width: number = 1024;
    height: number = 1024;
    samplerSeed: number = -1;
    sampler: string = "EULER";
    saveEveryEpoch: number = 5;
    savePrecision: string = "BFLOAT_16";
    learningRate: number = 1.0e-4;
    unetLr: number = 1.0e-4;
    textEncoderLr: number = 1.0e-4;
    lrWarmup: number = 0;
    lrScheduler: string = "LINEAR";
    optimizer: string = "ADAM_8BIT";
    lrSchedulerNumCycles: number = 1;
    trainUnetOnly: boolean = true;
    trainTextEncoderOnly: boolean = false;
    minSnrGamma: number = 0;
    noiseOffset: number = 0.1;
    seed: number = -1;
    clipSkip: number = 2;
    networkAlpha: number = 16;
    networkRankDim: number = 16;
}